<!-- eslint-disable vue/no-unused-components -->
<template lang="">
  <div class="content-box">
    <div class="section-box">
      <div class="das-form-container">
        <div class="das-form-group">
          <div>
            <span>Ngày đến: </span><span>{{ arriveDate }}</span
            >, <span>Ngày đi: </span>
            <span>{{ departDate }}</span>
          </div>
          <el-row :gutter="10">
            <el-col :span="15" style="height: 400px">
              <div class="grid-scroll" style="height: 100%">
                <GridVx
                  ref="agGridSericeApi"
                  :columns="columnsService2"
                  :rows="rowsService2"
                  class="agGrid"
                  dom-layout="scroll"
                  :auto-size-cell="true"
                  @rowClicked="onClickRowService"
                />
                <!--                       @selectionChanged="onSelectSpeSer" -->
              </div>
            </el-col>
            <el-col :span="9">
              <!-- <div class="header-form"> -->
              <!-- <div class="title-form">{{ formService.desc }}</div> -->
              <validation-observer
                ref="specialSvFormValidator"
                rules="required"
                :name="'Tên dịch vụ'"
              >
                <div class="das-form-col">
                  <div class="das-form-input">
                    <div class="label">Tên dịch vụ</div>
                    <input
                      v-model="formService.special_service_name"
                      disabled
                      type="text"
                    />
                  </div>
                </div>
                <!-- </div> -->

                <div
                  class="das-form-row gap"
                  style="flex-wrap: nowrap !important"
                >
                  <div class="das-form-col">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ this.$t('field.quantity') }}
                      </div>
                      <validation-provider
                        rules="required"
                        :name="this.$t('field.quantity')"
                      >
                        <input
                          v-model="formService.quantity"
                          type="number"
                          onkeypress="return  event.charCode >= 48 && event.charCode <= 57"
                        />
                      </validation-provider>
                    </div>
                  </div>
                  <div class="das-form-col">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ this.$t('field.specialUnitPrice') }}
                      </div>
                      <validation-provider
                        rules="required"
                        :name="this.$t('field.specialUnitPrice')"
                      >
                        <VxCurrencyInput
                          v-model="formService.price"
                          :disabled-flag="!formService.open_fee"
                          type="text"
                          onkeypress="return  event.charCode >= 48 && event.charCode <= 57"
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div
                  class="das-form-row gap"
                  style="flex-wrap: nowrap !important"
                >
                  <div class="das-form-col">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ this.$t('field.fromDate') }}
                      </div>
                      <validation-provider
                        rules="required"
                        :name="this.$t('field.fromDate')"
                      >
                        <CalendarSelect
                          :key="dataKey"
                          v-model="formService.service_start_date"
                          mode="date"
                          class="use-icon"
                          :date-data="formService.service_start_date"
                          :min-max="{
                            min: arriveDate,
                            max: departDate
                          }"
                          @input="changeCalendarStartDate"
                        />
                      </validation-provider>
                    </div>
                  </div>
                  <div class="das-form-col">
                    <div class="das-form-input">
                      <div class="label required">
                        {{ this.$t('field.toDate') }}
                      </div>
                      <validation-provider
                        rules="required"
                        :name="this.$t('field.toDate')"
                      >
                        <CalendarSelect
                          :key="dataKey"
                          v-model="formService.service_end_date"
                          mode="date"
                          class="use-icon"
                          :date-data="formService.service_end_date"
                          :min-max="{
                            min: arriveDate,
                            max: departDate
                          }"
                          @input="changeCalendarEndDate"
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>

                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">Ghi chú</div>
                      <textarea v-model="formService.note" :rows="3" />
                    </div>
                  </div>
                </div>
                <div v-show="shouldShowButtons" class="flex align-center">
                  <button
                    class="btn primary small"
                    style="margin-right: 10px"
                    @click="addSpecialService"
                  >
                    Thêm/Sửa
                  </button>
                  <button
                    v-if="canDeleteService"
                    class="btn pink outline small"
                    @click="removeSpecialService"
                  >
                    Xóa
                  </button>
                </div>
              </validation-observer>
            </el-col>
          </el-row>
          <div class="grid-scroll" style="margin-top: 20px; height: 200px">
            <GridVx
              ref="agGridTransactionApi"
              :columns="columnsTransaction"
              :rows="rowsTransaction"
              class="agGrid"
              dom-layout="scroll"
              :auto-size-cell="true"
              @rowClicked="onClickRowServiceToChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* disable-eslint */
import { CellRenderCheckboxReadonly } from '@/utils/groupCellRenders.js'
import { getSpecialServiceListApi } from '@/api/Service_Policy/specialService'
import { getUserApi } from '@/api/userConfig/user'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly
  },
  props: {
    specialServices: {
      type: Array,
      default: () => {
        return []
      }
    },
    visibleProp: {
      type: Boolean,
      default: false
    },
    arriveDate: {
      type: String,
      default: null
    },
    departDate: {
      type: String,
      default: null
    },
    bookingRoom: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      accountOptions: [],
      dataKey: 0,
      addFlag: null,
      addFlagDefault: null,

      columnsAccount: [
        {
          headerName: 'ID Nhân viên',
          field: 'id_card',
          width: 100
        },
        {
          headerName: 'Họ và tên',
          field: 'full_name'
        }
      ],
      columnsService2: [
        {
          headerName: 'Mã dịch vụ',
          field: 'code',
          minWidth: 100,
          cellStyle: params => {
            // if(params.value === 0) return {}
          }
        },
        {
          headerName: 'Dịch vụ đặc biệt',
          field: 'desc',
          tooltipField: 'desc',
          minWidth: 100,
          flex: 1
        },
        {
          headerName: 'Giá đơn vị',
          field: 'fee',
          minWidth: 100,
          maxWidth: 150,
          valueFormatter(params) {
            return params.value === null
              ? ''
              : Intl.NumberFormat().format(params.value)
          }
        },
        {
          headerName: 'Mở',
          field: 'open_price',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellClass: 'grid-cell-align-center',
          minWidth: 80,
          maxWidth: 80
        },
        {
          headerName: 'Tiền tệ',
          field: 'currency_code',
          minWidth: 90,
          maxWidth: 90
        },
        {
          headerName: 'Bao gồm trong tiền phòng',
          field: 'separate_room_fee',
          headerTooltip: 'Bao gồm trong tiền phòng',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellClass: 'grid-cell-align-center',
          minWidth: 100
        }
      ],
      rowsService2: [],
      // form special service
      defaultFormService: {
        id: null,
        code: '',
        desc: '',
        quantity: 1,
        note: '',
        currency: '',
        price: null,
        open_fee: false,
        special_service_id: null,
        booking_group_id: null,
        service_start_date: this.arriveDate,
        service_end_date: this.departDate,
        employee_id: null,
        employee_name: null
      },
      formService: {
        id: null,
        special_service_code: '',
        special_service_name: '',
        quantity: 1,
        note: '',
        currency: '',
        price: null,
        open_fee: false,
        special_service_id: null,
        booking_group_id: null,
        service_start_date: this.arriveDate,
        service_end_date: this.departDate,
        employee_id: null,
        employee_name: null,
        isAdded: false
      },
      columnsTransaction: [
        {
          headerName: 'Mã',
          minWidth: 100,
          field: 'special_service_code'
        },
        {
          headerName: 'Tên',
          minWidth: 100,
          field: 'special_service_name'
        },
        {
          headerName: 'Giá đơn vị',
          minWidth: 100,
          field: 'price',
          valueFormatter(params) {
            return params.value === null
              ? ''
              : Intl.NumberFormat().format(params.value)
          }
        },
        {
          headerName: 'Số lượng',
          minWidth: 100,
          field: 'quantity'
        },
        {
          headerName: 'Từ ngày',
          minWidth: 100,
          field: 'service_start_date',
          valueFormatter: params => {
            return this.$moment(params.value).format('DD-MM-Y')
          }
        },
        {
          headerName: 'Đến ngày',
          minWidth: 100,
          field: 'service_end_date',
          valueFormatter: params => {
            return this.$moment(params.value).format('DD-MM-Y')
          }
        },
        {
          headerName: 'Số ngày',
          minWidth: 100,
          field: 'total_price',
          valueGetter: params => {
            const totalDate =
              this.$moment(params.data.service_end_date).diff(
                params.data.service_start_date,
                'days'
              ) + 1
            return totalDate
          }
        },
        {
          headerName: 'Thành tiền',
          minWidth: 100,
          field: 'total_price',
          valueGetter: params => {
            const totalDate =
              this.$moment(params.data.service_end_date).diff(
                params.data.service_start_date,
                'days'
              ) + 1
            return (
              params.data.quantity * params.data.price * Math.max(totalDate, 1)
            )
          },
          valueFormatter(params) {
            return params.value === null
              ? ''
              : Intl.NumberFormat().format(params.value)
          }
        },
        // {
        //   headerName: 'Mở',
        //   field: 'open_fee',
        //   cellRenderer: 'CellRenderCheckboxReadonly'
        // },
        // {
        //   headerName: 'Tiền tệ',
        //   field: 'currency'
        // },

        {
          headerName: 'Ghi chú',
          field: 'note',
          minWidth: 100,
          flex: 1
        }
      ],
      rowsTransaction: [],
      formServiceTmpList: [] // / for form.special_services before confirm
    }
  },
  computed: {
    shouldShowButtons() {
      if (this.bookingRoom?.status === 2) {
        if (
          this.formService.id > this.addFlagDefault ||
          this.formService.isAdded
        ) {
          true
        } else {
          return false
        }
      }
      return true
    },
    canDeleteService() {
      return (
        (this.bookingRoom?.booking_room_status == null ||
          this.bookingRoom?.booking_room_status === 1) &&
        this.rowsTransaction.length > 0 &&
        this.formService.id !== null &&
        this.formService.id <= this.addFlag
      )
    }
  },
  mounted() {
    this.rowsTransaction = this.bookingRoom?.sub_booking_group_services
      ? [...this.bookingRoom?.sub_booking_group_services]
      : []
    this.addFlag = this.rowsTransaction.length
    this.addFlagDefault = this.rowsTransaction.length
    this.getSpecialService()
    this.getListAccount()
  },
  methods: {
    removeSpecialService() {
      const index = this.rowsTransaction.findIndex(
        item => item.id === this.formService.id
      )
      this.rowsTransaction.splice(index, 1)
      this.formService = { ...this.defaultFormService }
    },
    dehydrateTable() {
      return JSON.parse(JSON.stringify(this.rowsTransaction))
    },
    async getListAccount() {
      const data = await getUserApi({ is_active: true })
      const rowData = data.data.map(item => item.account)
      this.accountOptions = [...rowData]
      // this.accountOptions = data.data.map(item => item?.account)
    },
    onSelectEmployee_Service(val) {
      this.formService.employee_id = val.id
      this.formService.employee_name = val.full_name
    },
    onCloseDialog() {
      this.$emit('closeDialog')
    },
    async getSpecialService() {
      const data = await getSpecialServiceListApi({
        page_size: 100,
        page_num: 1,
        order_tp: 'ASC'
      })
      this.rowsService2 = [...data.data]
    },
    onClickRowService(row) {
      this.dataKey++
      this.formService.id = this.addFlag + 1
      this.formService.special_service_id = row[0].id
      this.formService.special_service_code = row[0].code
      this.formService.special_service_name = row[0].desc
      this.formService.price = parseInt(row[0].fee)
      // this.formService.code = row[0].code
      this.formService.open_fee = row[0].open_price
      this.formService.currency = row[0].currency_code
      // this.addFlag++
    },
    onClickRowServiceToChange(row) {
      this.dataKey++
      this.formService.id = row[0].id
      this.formService.isAdded = row[0].isAdded
      this.formService.special_service_id = row[0].special_service_id
      this.formService.special_service_code = row[0].special_service_code
      this.formService.special_service_name = row[0].special_service_name
      this.formService.price = row[0].price
      this.formService.open_fee = row[0].open_fee
      this.formService.currency = row[0].currency
      this.formService.service_start_date = row[0].service_start_date
      this.formService.service_end_date = row[0].service_end_date
      this.formService.note = row[0].note
      this.formService.employee_id = row[0].employee_id
      this.formService.employee_name = row[0].employee_name
      this.formService.quantity = row[0].quantity
    },
    async addSpecialService() {
      if (
        (await this.$vxForm.isValid(this.$refs.specialSvFormValidator)) ===
        false
      ) {
        return
      }
      const index = this.rowsTransaction.findIndex(
        item => item.id === this.formService.id
      )
      if (index !== -1) {
        this.rowsTransaction[index] = this.formService
        this.$refs.agGridTransactionApi.gridOptions.api.forEachNode(node => {
          if (node.data.id === this.formService.id) {
            node.setData(this.formService)
          }
        })
      } else if (this.formService.id) {
        this.formService.isAdded = true
        this.rowsTransaction.push(this.formService)
      }
      this.addFlag++
      this.formService = { ...this.defaultFormService }
    },
    confirmSpecialService() {
      this.$emit('confirmSpecialService', this.rowsTransaction)
      this.onCloseDialog()
    },

    changeCalendarStartDate(value) {
      this.formService.service_start_date = value
    },
    changeCalendarEndDate(value) {
      this.formService.service_end_date = value
    }
  }
}
</script>
<style lang=""></style>
